import { useCurrentFrame, useVideoConfig } from 'remotion';

/**
 * Frame-based cursor blink for Remotion video mode.
 * Returns opacity (1 or 0) matching VS Code blink timing (1.06s cycle).
 */
export function useCursorBlink() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const cycleLengthFrames = Math.round(1.06 * fps);
  const position = frame % cycleLengthFrames;
  return position < cycleLengthFrames / 2 ? 1 : 0;
}
